<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false" :before-close="handleClose" @open="handleOpen">
    <el-form :model="formData" :rules="formRules" ref="invoiceForm" label-width="120px" size="small">

      <el-row :gutter="20">
        <!-- 信息选择（仅申请和修改模式可操作） -->
        <el-col :span="12" v-if="dialogMode === 'apply' || dialogMode === 'edit'">
          <el-form-item label="信息选择">
            <el-input v-model="equipmentCodesDisplay" placeholder="点击选择" :readonly="isFieldDisabled" @click.native="handleSelectEquipment">
              <el-button slot="append" icon="el-icon-search" :disabled="isFieldDisabled" @click="handleSelectEquipment">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 设备合计（仅申请和修改模式可操作） -->
        <el-col :span="12" v-if="dialogMode === 'apply' || dialogMode === 'edit'">
          <el-form-item label="设备合计">
            <el-input v-model="formData.totalEquipment" :readonly="true" />
          </el-form-item>
        </el-col>
        <!-- 使用单位名称 -->
        <!-- 信息选择（详情和发票管理模式只展示） -->
        <el-col :span="12" v-if="dialogMode === 'detail' || dialogMode === 'invoice'">
          <el-form-item label="信息选择">
            <el-input v-model="equipmentCodesDisplay" :readonly="true" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <!-- 设备合计（详情和发票管理模式只展示） -->
        <el-col :span="12" v-if="dialogMode === 'detail' || dialogMode === 'invoice'">
          <el-form-item label="设备合计">
            <el-input v-model="formData.totalEquipment" :readonly="true" />
          </el-form-item>
        </el-col>
        <!-- 申请号（仅修改、发票管理、详情模式显示） -->
        <el-col :span="24" v-if="dialogMode !== 'apply'">
          <el-form-item label="申请号">
            <el-input v-model="formData.applyNo" :readonly="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 客户名称 -->
        <el-col :span="12">
          <el-form-item label="客户名称" prop="compName">
            <el-input v-model="formData.compName" placeholder="请输入客户名称" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>
        <!-- 单位名称 -->
        <el-col :span="12">
          <el-form-item label="使用单位名称" prop="useUntName">
            <el-input v-model="formData.useUntName" placeholder="请输入单位名称" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>

        <!-- 税号 -->
        <el-col :span="12">
          <el-form-item label="税号" prop="taxNo">
            <el-input v-model="formData.taxNo" placeholder="请输入税号" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>

        <!-- 开票单位名称 -->
        <el-col :span="12">
          <el-form-item label="开票单位名称" prop="invoiceUnitName">
            <el-input v-model="formData.invoiceUnitName" placeholder="请输入开票单位名称" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>

        <!-- 开票类型 -->
        <el-col :span="12">
          <el-form-item label="开票类型" prop="invoiceType">
            <el-select v-model="formData.invoiceType" placeholder="请选择开票类型" :disabled="isFieldDisabled" style="width: 100%;">
              <el-option label="普通发票" :value="0"></el-option>
              <el-option label="专用发票" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 税率 -->
        <el-col :span="12">
          <el-form-item label="税率" prop="taxRate">
            <el-select v-model="formData.taxRate" placeholder="请选择税率" :disabled="isFieldDisabled" style="width: 100%;" @change="handleTaxRateChange">
              <el-option label="1%" :value="0.01"></el-option>
              <el-option label="3%" :value="0.03"></el-option>
              <el-option label="6%" :value="0.06"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 开票金额 -->
        <el-col :span="12">
          <el-form-item label="开票金额" prop="invoiceAmount">
            <el-input v-model="formData.invoiceAmount" placeholder="请输入开票金额" :readonly="isFieldDisabled" @input="handleInvoiceAmountChange" oninput="value=value.replace(/[^\d.]/g,'')">
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>

        <!-- 不含税金额（自动计算） -->
        <el-col :span="12">
          <el-form-item label="不含税金额">
            <el-input v-model="formData.taxFreeAmount" :readonly="true">
              <template slot="prepend">￥</template>
            </el-input>
          </el-form-item>
        </el-col>

        <!-- 税额（自动计算） -->
        <el-col :span="12">
          <el-form-item label="税额">
            <el-input v-model="formData.taxAmount" :readonly="true">
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>

        <!-- 申请日期 -->
        <el-col :span="12">
          <el-form-item label="申请日期" prop="applyTime">
            <el-date-picker v-model="formData.applyTime" type="date" placeholder="选择申请日期" value-format="yyyy-MM-dd" disabled style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <!-- 申请人 -->
        <el-col :span="12">
          <el-form-item label="申请人" prop="applicantName">
            <el-input v-model="formData.applicantName" placeholder="请输入申请人" readonly />
          </el-form-item>
        </el-col>

        <!-- 开票主体 -->
        <el-col :span="12">
          <el-form-item label="开票主体" prop="invoiceSubject">
            <el-select v-model="formData.invoiceSubject" placeholder="请选择开票主体" :disabled="isFieldDisabled" style="width: 100%;" @change="handleInvoiceEntityChange">
              <el-option label="晨宇安全科技集团有限公司" value="晨宇安全科技集团有限公司"></el-option>
              <el-option label="晨宇安全科技集团有限公司泉州分公司" value="晨宇安全科技集团有限公司泉州分公司"></el-option>
              <el-option label="晨宇安全科技集团有限公司漳州分公司" value="晨宇安全科技集团有限公司漳州分公司"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 银行账号 -->
        <el-col :span="12">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="formData.bankAccount" placeholder="请输入银行账号" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>

        <!-- 地址 -->
        <el-col :span="12">
          <el-form-item label="地址" prop="address">
            <el-input v-model="formData.address" placeholder="请输入地址" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>

        <!-- 电话 -->
        <el-col :span="12">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入电话" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>
        <!-- 开户银行 -->
        <el-col :span="12">
          <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="formData.bankName" placeholder="请输入开户银行" :readonly="isFieldDisabled" />
          </el-form-item>
        </el-col>
        <!-- 原发票号（仅发票管理模式可编辑） -->
        <el-col :span="12" v-if="(dialogMode === 'invoice' || dialogMode === 'detail') && formData.applyStatus === 3">
          <el-form-item label="原发票号" :prop="dialogMode === 'invoice' ? 'originInvoiceNo' : ''">
            <el-input v-model="formData.originInvoiceNo" placeholder="请输入原发票号" :readonly="dialogMode === 'detail'" />
          </el-form-item>
        </el-col>

        <!-- 原开票日期（仅发票管理模式可编辑） -->
        <el-col :span="12" v-if="(dialogMode === 'invoice' || dialogMode === 'detail') && formData.applyStatus === 3">
          <el-form-item label="原开票日期" :prop="dialogMode === 'invoice' ? 'originInvoiceTime' : ''">
            <el-date-picker v-model="formData.originInvoiceTime" type="date" placeholder="选择原开票日期" value-format="yyyy-MM-dd" :disabled="dialogMode === 'detail'" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <!-- 新发票号（仅发票管理模式可编辑） -->
        <el-col :span="12" v-if="dialogMode === 'invoice' || dialogMode === 'detail'">
          <el-form-item label="新发票号" :prop="dialogMode === 'invoice' ? 'invoiceNo' : ''">
            <el-input v-model="formData.invoiceNo" placeholder="请输入发票号" :readonly="dialogMode === 'detail'" />
          </el-form-item>
        </el-col>

        <!-- 新开票日期（仅发票管理模式可编辑） -->
        <el-col :span="12" v-if="dialogMode === 'invoice' || dialogMode === 'detail'">
          <el-form-item label="新开票日期" :prop="dialogMode === 'invoice' ? 'invoiceTime' : ''">
            <el-date-picker v-model="formData.invoiceTime" type="date" placeholder="选择开票日期" value-format="yyyy-MM-dd" :disabled="dialogMode === 'detail'" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <!-- 备注 -->
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" :readonly="dialogMode === 'detail'" />
          </el-form-item>
        </el-col>

        <!-- 上传pdf -->
        <el-col :span="24" v-if="dialogMode == 'invoice'">
          <el-form-item label="文件上传">
            <el-upload class="upload-demo" action="#" :http-request="uploadFile" :file-list="fileList" :on-remove="handleRemove" :before-upload="beforeUpload" accept=".pdf">
              <el-button size="small" type="primary">点击上传PDF</el-button>
              <div slot="tip" class="el-upload__tip">只能上传PDF文件</div>
              <div v-if="tipText" class="el-upload__tip">{{ tipText }}</div>
            </el-upload>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading" v-if="!isDisabled">确 定</el-button>
    </span>

    <!-- 识别码选择弹窗 -->
    <el-dialog title="选择识别码" :visible.sync="equipmentDialogVisible" width="1000px" append-to-body :close-on-click-modal="false">
      <el-form size="small" class="equipment-search-form">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="使用单位">
              <el-input v-model="equipmentQuery.usingUnit" placeholder="使用单位" clearable @keyup.enter.native="handleQueryEquipment" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="小区名称">
              <el-input v-model="equipmentQuery.houseName" placeholder="小区名称" clearable @keyup.enter.native="handleQueryEquipment" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="到检年月">
              <el-date-picker v-model="equipmentQuery.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQueryEquipment" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="识别码">
              <el-input v-model="equipmentQuery.oidNo" placeholder="识别码" clearable @keyup.enter.native="handleQueryEquipment" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="客户名称">
              <el-input v-model="equipmentQuery.compName" placeholder="客户名称" clearable @keyup.enter.native="handleQueryEquipment" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button type="primary" icon="el-icon-search" @click="handleQueryEquipment">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleResetEquipment">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table ref="equipmentTable" :data="equipmentList" border style="width: 100%; margin-top: 10px" max-height="400" @selection-change="handleEquipmentSelectionChange"
                :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="equipmentLoading">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="识别码" align="center" prop="code" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="客户名称" align="center" prop="compName" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="使用单位" align="center" prop="useUnit" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="小区名称" align="center" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="到检年月" align="center" prop="inspectionMonth" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="税号" align="center" prop="unifiedCreditCode" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="开票主体" align="center" prop="invoiceSubject" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>

      <el-pagination @size-change="handleEquipmentSizeChange" @current-change="handleEquipmentCurrentChange" :current-page="equipmentQuery.currPage" :page-sizes="[10, 20, 50,100,200,500]"
                     :page-size="equipmentQuery.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="equipmentTotal" style="margin-top: 10px; text-align: right;">
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="equipmentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmEquipment">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { saveInvoice, updateInvoice, manageInvoice, queryInvoiceDetail, invoiceOidnos } from '@/api/contract/contract';
import { appjs } from '@/utiljs/apputil';

export default {
  name: 'InvoiceDialog',
  data () {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 弹窗模式：apply-申请, edit-修改, invoice-发票管理, detail-详情
      dialogMode: 'apply',
      // 提交加载状态
      submitLoading: false,
      // 文件上传相关
      fileList: [], // 文件列表
      uploadedFileUUID: '', // 上传后的文件UUID
      tipText: '', // 上传提示文本
      // 表单数据（使用后台字段名）
      formData: {
        id: undefined, // 记录ID（修改时使用）
        applyNo: '', // 申请号（后台字段）
        invoiceSubject: '', // 开票主体（后台字段）
        compName: '', // 客户名称（后台字段，识别码选择带出）
        useUntName: '', // 单位名称（后台字段）
        taxNo: '', // 税号
        taxRate: '', // 税率（数值格式，如 0.06）
        invoiceAmount: '', // 开票金额（含税）
        taxFreeAmount: '', // 不含税金额（后台字段）
        taxAmount: '', // 税额
        invoiceUnitName: '', // 开票单位名称
        invoiceType: '', // 开票类型 0=普通发票，1=专用发票
        bankName: '', // 开户银行
        bankAccount: '', // 银行账号
        applyTime: '', // 申请时间（后台字段）
        applicantId: undefined, // 申请人 ID（后台字段）
        applicantName: '', // 申请人姓名（后台字段）
        oidNoList: [], // 识别码数组（后台字段）
        address: '', // 地址（后台字段）
        phone: '', // 电话（后台字段）
        invoiceNo: '', // 发票号
        invoiceTime: '', // 开票时间
        originInvoiceNo: '', // 原发票号
        originInvoiceTime: '', // 原开票时间
        totalEquipment: '', // 设备合计（勾选设备条数）
        remark: '' // 备注
      },
      // 红冲标识（历史遗留：建议统一使用 formData.applyStatus，这里保留字段避免其它逻辑引用时报错）
      HCapplyStatus: 0,
      // 基础表单验证规则（使用后台字段名）
      // 注意：Element-UI 的 el-form 校验不会自动跳过 disabled 字段，因此真正绑定给 el-form 的规则需要按模式动态裁剪
      baseFormRules: {
        invoiceSubject: [
          { required: true, message: '请选择开票主体', trigger: 'change' }
        ],
        compName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        useUntName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请选择税率', trigger: 'change' }
        ],
        invoiceAmount: [
          { required: true, message: '请输入开票金额', trigger: 'blur' }
        ],
        invoiceUnitName: [
          { required: true, message: '请输入开票单位名称', trigger: 'blur' }
        ],
        invoiceType: [
          { required: true, message: '请选择开票类型', trigger: 'change' }
        ],
        applyTime: [
          { required: true, message: '请选择申请日期', trigger: 'change' }
        ],
        applicantName: [
          { required: true, message: '请输入申请人', trigger: 'blur' }
        ],
        // 发票管理模式的验证规则
        invoiceNo: [
          { required: true, message: '请输入发票号', trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: '请选择开票日期', trigger: 'change' }
        ],
        // 原发票管理模式的验证规则
        originInvoiceNo: [
          { required: true, message: '请输入原发票号', trigger: 'blur' }
        ],
        originInvoiceTime: [
          { required: true, message: '请选择原开票日期', trigger: 'change' }
        ],
      },
      // 识别码选择弹窗
      equipmentDialogVisible: false,
      equipmentLoading: false,
      equipmentList: [],
      equipmentTotal: 0,
      equipmentQuery: {
        currPage: 1,
        pageSize: 500,
        usingUnit: '',      // 使用单位
        houseName: '',    // 小区名称
        inspectionMonthList: [], // 到检年月
        oidNo: ''           // 识别码
      },
      selectedEquipments: [] // 已选择的设备
    };
  },
  computed: {
    /**
     * 弹窗标题
     */
    dialogTitle () {
      switch (this.dialogMode) {
        case 'apply':
          return '发票申请';
        case 'edit':
          return '修改发票申请';
        case 'invoice':
          return '发票管理';
        case 'detail':
          return '发票详情';
        default:
          return '发票申请';
      }
    },

    /**
     * 是否禁用输入（详情模式禁用所有输入，发票管理模式部分禁用）
     */
    isDisabled () {
      if (this.dialogMode === 'detail') {
        return true;
      }
      // 发票管理模式下，除了发票号、开票日期、备注外都禁用，但不影响确定按钮显示
      return false;
    },

    /**
     * 是否禁用表单字段（发票管理模式下大部分字段禁用）
     */
    isFieldDisabled () {
      if (this.dialogMode === 'detail') {
        return true;
      }
      if (this.dialogMode === 'invoice') {
        return true; // 发票管理模式下，除了发票号、开票日期、备注外都禁用
      }
      return false;
    },

    /**
     * 识别码显示文本
     */
    equipmentCodesDisplay () {
      if (this.formData.oidNoList && this.formData.oidNoList.length > 0 && this.formData.oidNoList !== null) {
        // ElInput 的 value 只能是 String/Number，这里把数组拼成字符串展示
        return this.formData.oidNoList.join('，');
      }
      return '';
    },

    /**
     * 按当前模式返回实际生效的校验规则
     * - detail：全部只读，不做校验
     * - invoice：只校验可编辑字段（新发票号/新开票日期；如有换开发票则校验原发票号/原开票日期）
     * - apply/edit：校验基础必填项
     */
    formRules () {
      // 详情模式：完全禁用，不需要校验
      if (this.dialogMode === 'detail') return {};

      // 发票管理模式：仅校验可编辑字段
      if (this.dialogMode === 'invoice') {
        const rules = {
          invoiceNo: this.baseFormRules.invoiceNo,
          invoiceTime: this.baseFormRules.invoiceTime
        };
        // 只有红冲（applyStatus=3）才展示/编辑原发票信息；校验条件必须与展示条件一致
        if (this.formData && this.formData.applyStatus === 3) {
          rules.originInvoiceNo = this.baseFormRules.originInvoiceNo;
          rules.originInvoiceTime = this.baseFormRules.originInvoiceTime;
        }
        return rules;
      }

      // 申请/修改模式：按基础规则校验
      return this.baseFormRules;
    }
  },
  watch: {
    // 模式切换/字段禁用状态变化时，清理旧的校验错误（避免“禁用后还显示必填红字”）
    dialogMode () {
      this.$nextTick(() => {
        this.$refs.invoiceForm && this.$refs.invoiceForm.clearValidate();
      });
    },
    isFieldDisabled () {
      this.$nextTick(() => {
        this.$refs.invoiceForm && this.$refs.invoiceForm.clearValidate();
      });
    }
  },
  methods: {
    /**
     * 打开弹窗
     * @param {String} mode - 弹窗模式：apply, edit, invoice, detail
     * @param {Object} rowData - 行数据（修改、发票管理、详情模式需要）
     */
    openDialog (mode, rowData = null) {
      this.dialogMode = mode;
      this.dialogVisible = true;
      // 兼容历史字段：红冲状态以 applyStatus=3 判断；这里同步一份避免其它逻辑引用 HCapplyStatus 时出问题
      if (rowData && typeof rowData.applyStatus !== 'undefined') {
        this.HCapplyStatus = rowData.applyStatus;
      } else {
        this.HCapplyStatus = 0;
      }
      // 根据模式初始化表单数据
      if (mode === 'apply') {
        // 申请模式：初始化默认值
        this.initApplyData();
      } else if (mode === 'edit' || mode === 'invoice' || mode === 'detail') {
        // 修改、发票管理、详情模式：加载现有数据
        this.loadFormData(rowData);
      }
    },

    /**
     * 初始化申请数据（申请模式）
     */
    initApplyData () {
      const today = this.formatDate(new Date());
      this.formData = {
        id: undefined,
        applyNo: '',
        invoiceSubject: '',
        compName: '',
        useUntName: '',
        taxNo: '',
        taxRate: '',
        invoiceAmount: '',
        taxFreeAmount: '',
        taxAmount: '',
        invoiceUnitName: '',
        invoiceType: '',
        bankName: '',
        bankAccount: '',
        applyTime: today, // 默认当天
        applicantId: undefined,
        applicantName: this.getCurrentUser(), // 默认当前用户
        oidNoList: [],
        address: '',
        phone: '',
        invoiceNo: '',
        invoiceTime: '',
        originInvoiceNo: '', // 原发票号
        originInvoiceTime: '', // 原开票时间
        totalEquipment: '',
        remark: '',
        entrustNumList: [],
      };
    },

    /**
     * 加载表单数据（修改、发票管理、详情模式）
     * @param {Object} rowData - 行数据
     */
    loadFormData (rowData) {
      if (!rowData || !rowData.id) return;

      // 调用详情 API 获取完整数据
      queryInvoiceDetail(rowData.id).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const data = res.additionalData;
          this.formData = {
            id: data.id,
            applyNo: data.applyNo || '',
            invoiceSubject: data.invoiceSubject || '',
            compName: data.compName || '',
            useUntName: data.useUntName || '',
            taxNo: data.taxNo || '',
            taxRate: data.taxRate || '',
            invoiceAmount: data.invoiceAmount || '',
            taxFreeAmount: data.taxFreeAmount || '',
            taxAmount: data.taxAmount || '',
            applyTime: data.applyTime || '',
            applicantId: data.applicantId,
            applicantName: data.applicantName || '',
            oidNoList: data.oidNoList || [],
            address: data.address || '',
            phone: data.phone || '',
            invoiceNo: data.invoiceNo || '',
            invoiceTime: data.invoiceTime || this.formatDate(new Date()),
            originInvoiceNo: data.originInvoiceNo || '',
            originInvoiceTime: data.originInvoiceTime || this.formatDate(new Date()),
            totalEquipment: data.totalEquipment || ((data.oidNoList && data.oidNoList.length) ? data.oidNoList.length : 0),
            remark: data.remark || '',
            applyStatus: data.applyStatus,
            bankName: data.bankName || '',
            invoiceType: data.invoiceType,
            invoiceUnitName: data.invoiceUnitName,
            bankAccount: data.bankAccount || '',
            entrustNumList: data.entrustNumList,
          };
          console.log(this.formData, data);

        } else {
          this.$message.error((res && res.retMsg) || '获取发票详情失败');
        }
      }).catch(error => {
        console.error('获取发票详情失败:', error);
        this.$message.error('获取发票详情失败');
      });
    },

    /**
     * 弹窗打开时的回调
     */
    handleOpen () {
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.invoiceForm) {
          this.$refs.invoiceForm.clearValidate();
        }
      });
    },

    /**
     * 关闭弹窗
     */
    handleClose () {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm () {
      if (this.$refs.invoiceForm) {
        this.$refs.invoiceForm.resetFields();
      }
      this.formData = {
        id: undefined,
        applyNo: '',
        invoiceSubject: '',
        compName: '',
        useUntName: '',
        taxNo: '',
        taxRate: '',
        invoiceAmount: '',
        taxFreeAmount: '',
        taxAmount: '',
        applyTime: '',
        applicantId: undefined,
        applicantName: '',
        oidNoList: [],
        address: '',
        phone: '',
        invoiceNo: '',
        invoiceTime: '',
        originInvoiceNo: '', // 原发票号
        originInvoiceTime: '', // 原开票时间
        totalEquipment: '',
        remark: ''
      };
      this.selectedEquipments = [];
      // 清空文件上传相关数据
      this.fileList = [];
      this.uploadedFileUUID = '';
      this.tipText = '';
    },

    /**
     * 开票主体变化时的处理
     * 总公司默认税率6%，分公司默认税率1%
     */
    handleInvoiceEntityChange (value) {
      if (value === '晨宇安全科技集团有限公司') {
        this.formData.taxRate = 0.06; // 6%
      } else {
        this.formData.taxRate = 0.01; // 1%
      }
      // 税率变化后重新计算
      this.calculateTax();
    },

    /**
     * 税率变化时的处理
     */
    handleTaxRateChange () {
      this.calculateTax();
    },

    /**
     * 开票金额变化时的处理
     */
    handleInvoiceAmountChange () {
      this.calculateTax();
    },

    /**
     * 计算税额和不含税金额
     * 计算公式：
     * 不含税金额 = 开票金额 / (1 + 税率)
     * 税额 = 开票金额 - 不含税金额
     */
    calculateTax () {
      const invoiceAmount = parseFloat(this.formData.invoiceAmount);
      const taxRate = parseFloat(this.formData.taxRate);

      if (isNaN(invoiceAmount) || isNaN(taxRate) || invoiceAmount <= 0 || taxRate < 0) {
        this.formData.taxFreeAmount = '';
        this.formData.taxAmount = '';
        return;
      }

      // 计算不含税金额（税率已经是小数形式，如 0.06）
      const taxFreeAmount = invoiceAmount / (1 + taxRate);
      // 计算税额
      const taxAmount = invoiceAmount - taxFreeAmount;

      // 保留两位小数
      this.formData.taxFreeAmount = taxFreeAmount.toFixed(2);
      this.formData.taxAmount = taxAmount.toFixed(2);
    },

    /**
     * 打开识别码选择弹窗
     */
    handleSelectEquipment () {
      if (this.isFieldDisabled) return;
      this.equipmentDialogVisible = true;
      this.getEquipmentList();
    },

    /**
     * 查询设备列表
     * 调用后台API获取识别码列表
     */
    getEquipmentList () {
      this.equipmentLoading = true;

      // 构建搜索参数
      const params = {};
      if (this.equipmentQuery.usingUnit) {
        params.usingUnit = this.equipmentQuery.usingUnit;
      }
      if (this.equipmentQuery.houseName) {
        params.houseName = this.equipmentQuery.houseName;
      }
      if (this.equipmentQuery.inspectionMonthList && this.equipmentQuery.inspectionMonthList.length) {
        params.inspectionMonthList = this.equipmentQuery.inspectionMonthList;
      }
      if (this.equipmentQuery.oidNo) {
        params.oidNo = this.equipmentQuery.oidNo;
      }
      if (this.equipmentQuery.compName) {
        params.compName = this.equipmentQuery.compName;
      }

      // 调用查询设备列表的API
      invoiceOidnos(params).then(res => {
        if (res && res.retCode === 'ok') {
          const eqList = (res && res.additionalData) ? res.additionalData : [];
          // 返回值为对象数组，映射新字段
          this.equipmentList = (Array.isArray(eqList) ? eqList : []).map(item => ({
            id: item.oidNo,
            code: item.oidNo,
            compName: item.compName || item.customerName || '',
            useUnit: item.usingUnit || '',
            houseName: item.houseName || '',
            inspectionMonth: item.inspectionMonth || '',
            unifiedCreditCode: item.unifiedCreditCode || '',
            invoiceSubject: item.invoiceSubject || '', // 开票主体
            // 金额字段：后端返回的是 finalPrice（数字类型），如果没有再兼容其它可能字段
            amount: item.totalTestAmount || item.amount || item.invoiceAmount || item.price || item.cooperationFee || 0,
            entrustNum: item.entrustNum || '',
          }));
          this.equipmentTotal = this.equipmentList.length;
          // 根据已选识别码恢复勾选状态
          this.$nextTick(() => {
            this.syncEquipmentSelection();
          });
        } else {
          this.$message.error((res && res.retMsg) || '获取设备列表失败');
        }
        this.equipmentLoading = false;
      }).catch(error => {
        console.error('获取设备列表失败:', error);
        this.equipmentLoading = false;
        this.$message.error('获取设备列表失败');
      });
    },

    /**
     * 查询设备按钮
     */
    handleQueryEquipment () {
      this.equipmentQuery.currPage = 1;
      this.getEquipmentList();
    },

    /**
     * 重置设备查询
     */
    handleResetEquipment () {
      this.equipmentQuery = {
        currPage: 1,
        pageSize: 10,
        usingUnit: '',
        houseName: '',
        inspectionMonthList: [],
        oidNo: ''
      };
      this.getEquipmentList();
    },

    /**
     * 设备选择改变
     */
    handleEquipmentSelectionChange (selection) {
      this.selectedEquipments = selection;
    },

    /**
     * 根据已选识别码恢复表格勾选状态
     * 场景：已经选择过识别码后再次打开弹窗时，自动勾选之前已选中的数据
     */
    syncEquipmentSelection () {
      const table = this.$refs.equipmentTable;
      if (!table) return;

      // 清空现有选择
      table.clearSelection();

      // 如果当前表单中没有已选识别码，则不需要恢复
      if (!this.formData.oidNoList || this.formData.oidNoList.length === 0) {
        this.selectedEquipments = [];
        return;
      }

      const selectedCodeSet = new Set(this.formData.oidNoList);
      const matchedRows = this.equipmentList.filter(item => selectedCodeSet.has(item.code));

      matchedRows.forEach(row => {
        table.toggleRowSelection(row, true);
      });

      // 同步本地已选择列表
      this.selectedEquipments = matchedRows;
    },

    /**
     * 确认选择设备
     */
    handleConfirmEquipment () {
      if (this.selectedEquipments.length === 0) {
        this.$message.warning('请至少选择一个识别码');
        return;
      }
      // 提取识别码（使用后台字段名 oidNoList）
      this.formData.oidNoList = this.selectedEquipments.map(item => item.code);
      this.formData.entrustNumList = this.selectedEquipments.map(item => item.entrustNum);
      this.formData.totalEquipment = this.selectedEquipments.length;

      // 计算所有选中识别码的金额总和
      const totalAmount = this.selectedEquipments.reduce((sum, item) => {
        const amount = parseFloat(item.amount) || 0;
        return sum + amount;
      }, 0);

      // 回填总金额到开票金额
      if (totalAmount > 0) {
        this.formData.invoiceAmount = totalAmount.toFixed(2);
        // 重新计算税额和不含税金额
        this.calculateTax();
      }

      // 回填第一条记录的使用单位名称和税号
      const firstItem = this.selectedEquipments[0];
      if (firstItem) {
        // 回填开票主体并触发税率计算
        if (firstItem.invoiceSubject) {
          this.formData.invoiceSubject = firstItem.invoiceSubject;
          // 调用开票主体变更处理，带出对应税率
          this.handleInvoiceEntityChange(firstItem.invoiceSubject);
        }

        if (firstItem.compName) {
          this.formData.compName = firstItem.compName;
        }
        if (firstItem.useUnit) {
          this.formData.useUntName = firstItem.useUnit;
          this.formData.invoiceUnitName = firstItem.useUnit;
        }
        if (firstItem.unifiedCreditCode) {
          this.formData.taxNo = firstItem.unifiedCreditCode;
        }
      }

      this.equipmentDialogVisible = false;
      this.$message.success(`已选择 ${this.selectedEquipments.length} 个识别码`);
    },

    /**
     * 设备列表分页大小改变
     */
    handleEquipmentSizeChange (val) {
      this.equipmentQuery.pageSize = val;
      this.getEquipmentList();
    },

    /**
     * 设备列表当前页改变
     */
    handleEquipmentCurrentChange (val) {
      this.equipmentQuery.currPage = val;
      this.getEquipmentList();
    },

    /**
     * 提交表单
     */
    handleSubmit () {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          // 新发票号 & 原发票号同时渲染时（发票管理模式 + applyStatus=3）
          // 需要校验两者不能一致；一致则阻止提交并提示用户
          const applyStatus = Number(this.formData.applyStatus);
          const shouldCheckInvoiceNo =
            this.dialogMode === 'invoice' && applyStatus === 3;
          if (shouldCheckInvoiceNo) {
            const originInvoiceNo = (this.formData.originInvoiceNo || '').trim();
            const invoiceNo = (this.formData.invoiceNo || '').trim();
            if (originInvoiceNo && invoiceNo && originInvoiceNo === invoiceNo) {
              this.$message.warning('新发票号与原发票号不能一致');
              return;
            }
          }

          this.submitLoading = true;

          // 根据不同模式调用不同的API
          if (this.dialogMode === 'apply') {
            this.submitApply();
          } else if (this.dialogMode === 'edit') {
            this.submitEdit();
          } else if (this.dialogMode === 'invoice') {
            this.submitInvoice();
          }
        } else {
          this.$message.warning('请完善必填项');
          return false;
        }
      });
    },

    /**
     * 提交申请
     */
    submitApply () {
      // 调用新增发票申请的API
      saveInvoice(this.formData).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success('申请成功');
          this.handleClose();
          this.$emit('refresh');
        } else {
          this.$message.error((res && res.retMsg) || '申请失败');
        }
        this.submitLoading = false;
      }).catch(error => {
        console.error('申请失败:', error);
        this.$message.error('申请失败');
        this.submitLoading = false;
      });
    },

    /**
     * 提交修改
     */
    submitEdit () {
      // 调用修改发票申请的API，包含上传的文件UUID
      const submitData = {
        ...this.formData,

      };

      updateInvoice(submitData).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success('修改成功');
          this.handleClose();
          this.$emit('refresh');
        } else {
          this.$message.error((res && res.retMsg) || '修改失败');
        }
        this.submitLoading = false;
      }).catch(error => {
        console.error('修改失败:', error);
        // this.$message.error('修改失败');
        this.submitLoading = false;
      });
    },

    /**
     * 提交发票管理（发票管理模式）
     */
    submitInvoice () {
      // 调用发票管理 API，只提交 id、invoiceNo、invoiceTime
      const data = {
        id: this.formData.id,
        invoiceNo: this.formData.invoiceNo,
        invoiceTime: this.formData.invoiceTime,
        originInvoiceNo: this.formData.originInvoiceNo,
        originInvoiceTime: this.formData.originInvoiceTime,
        invoiceFileName: this.uploadedFileUUID, // 添加文件UUID
        totalEquipment: this.formData.totalEquipment,
        entrustNumList: this.formData.entrustNumList,
      };

      manageInvoice(data).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success('发票信息录入成功');
          this.handleClose();
          this.$emit('refresh');
        } else {
          this.$message.error((res && res.retMsg) || '发票信息录入失败');
        }
        this.submitLoading = false;
      }).catch(error => {
        console.error('发票信息录入失败:', error);
        this.$message.error('发票信息录入失败');
        this.submitLoading = false;
      });
    },

    /**
     * 获取当前用户
     * 从 Vuex store 中获取当前登录用户名
     */
    getCurrentUser () {
      // 从 store 中获取当前登录用户名
      return this.$store.state.loginUser.userName || '未知用户';
    },

    /**
     * 格式化日期
     * @param {Date} date - 日期对象
     * @returns {String} 格式化后的日期字符串 yyyy-MM-dd
     */
    formatDate (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    /**
     * 上传文件前的校验
     */
    beforeUpload (file) {
      const isPDF = file.type === 'application/pdf';
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isPDF) {
        this.$message.error('只能上传PDF格式的文件！');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB！');
        return false;
      }
      return true;
    },

    /**
     * 自定义上传文件
     */
    uploadFile (fileData) {
      const _self = this;
      const formdata = new FormData();
      formdata.append("file", fileData.file);
      const name = fileData.file.name;
      const type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);

      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        _self.tipText = "文件上传中:" + ((event.loaded / event.total) * 100).toFixed(0) + "%";
      }).then((data) => {
        if (data.retCode && data.retCode != "ok") {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg);
          _self.tipText = '';
        } else {
          fileData.onSuccess();
          // 保存文件UUID
          _self.uploadedFileUUID = data.retMsg;
          _self.fileList.push({
            fileUUID: data.retMsg,
            fileName: name,
            name: name,
            uid: fileData.file.uid
          });
          _self.tipText = '上传完成！';
          appjs.showSuccessMsg("上传成功");
        }
      }).catch((error) => {
        appjs.showErrorMsg("异常：" + error);
        _self.tipText = '';
      });
    },

    /**
     * 移除文件
     */
    handleRemove (file, fileList) {
      // 从文件列表中移除
      this.fileList = fileList;
      // 如果移除的是已上传的文件，清空UUID
      if (file.fileUUID === this.uploadedFileUUID) {
        this.uploadedFileUUID = '';
      }
      this.tipText = '';
    }
  }
};
</script>

<style scoped>
/* 设备搜索表单样式 */
.equipment-search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 10px;
}
.equipment-search-form .el-form-item__label {
  padding-right: 5px;
}
</style>
